import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconBubbleWide: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="bubble-wide, message, chat"><path d="M3.75 3C2.7835 3 2 3.7835 2 4.75V17.25C2 18.2165 2.7835 19 3.75 19H8.65182C8.71055 19 8.76741 19.0207 8.81242 19.0584L10.8775 20.7894C11.5249 21.3321 12.4676 21.3348 13.1181 20.7959L15.2164 19.0575C15.2613 19.0203 15.3177 19 15.3759 19H20.25C21.2165 19 22 18.2165 22 17.25V4.75C22 3.7835 21.2165 3 20.25 3H3.75Z" fill="currentColor"/></CentralIconBase>;
};

export default IconBubbleWide;
